import {IGlobalStore} from 'modules/types';

export const getStats = (state: IGlobalStore) => {
	return state.stats || {}
};
